import { Accordion } from '@base-ui/react/accordion';
import styled from 'styled-components';
import { theme } from 'modules/tetrisTheme';
export const AccordionContainer = styled(Accordion.Root) `
  width: 100%;
  display: flex;
  flex-direction: column;
  background-color: ${theme.semantic.surface.primary};
  gap: ${theme.spacing.sm};
`;
